module.exports = __webpack_public_path__ + "media/vendor/leap/pages/assets/img/icons/theme/weather/thunder-d2971f287a66c23388bf1da875b81541.svg";